module.exports = __webpack_public_path__ + "images/tour/invite.dd962face0452ff3e155.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/invite.svg
// module id = JCHg
// module chunks = 1